import { enablePosthog, disablePosthog } from "../javascripts/analytics"

export default {
  updateConsent(consentValue, callback = null) {
    fetch('/participants/update_consent', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector("meta[name='csrf-token']").content
      },
      body: JSON.stringify({ 
        rgpd_consent: consentValue, 
        rgpd_consent_date: new Date().toISOString() 
      })
    })
    .then(response => {
      if (response.ok) {
        if (consentValue === true) {
          enablePosthog();
        } else {
          disablePosthog();
        }
        
        if (callback) callback(true);
      } else {
        console.error("Failed to update consent");
        if (callback) callback(false);
      }
    })
    .catch(error => {
      console.error("Error updating consent:", error);
      if (callback) callback(false, error);
    });
  }
} 